import { createSlice } from "@reduxjs/toolkit";

const INIT_STATE = {
  selectedSurveyId: null,
};

const selectedSurveyId = createSlice({
  name: "selectedSurveyId",
  initialState: INIT_STATE,
  reducers: {
    addSelectedSurveyId(state, action) {
      state.selectedSurveyId = action.payload;
    },
  },
});

export const { addSelectedSurveyId } = selectedSurveyId.actions;

export default selectedSurveyId.reducer;
